import React from 'react';
import LegalLayout, {
  LegalSection,
  LegalParagraph,
  LegalList,
  LegalNote
} from './LegalLayout';

const PhotoConsent = () => (
  <LegalLayout
    title="Photo &amp; Video Consent Information"
    effectiveDate="Effective from 1 June 2026"
    pageTestId="photo-consent-page"
  >
    <LegalParagraph>
      At Read Right Academy, we occasionally capture photos or short video
      clips during our lessons, workshops, and events. This page explains how
      we use these images and how you can control the use of your child&apos;s
      image.
    </LegalParagraph>

    <LegalSection heading="1. What We Mean by Photos &amp; Videos">
      <LegalList
        items={[
          'Screenshots taken during online classes',
          'Photos shared by parents (e.g. of their child engaging with our materials)',
          'Short recordings used for parent review, training, or showcasing learning moments'
        ]}
      />
    </LegalSection>

    <LegalSection heading="2. How We May Use Them">
      <LegalParagraph>
        Subject to your written consent, we may use photos or short clips to:
      </LegalParagraph>
      <LegalList
        items={[
          'Show learning moments on our website, Facebook, LinkedIn, or Instagram',
          'Train our own teachers in best-practice early literacy methods',
          'Illustrate articles, brochures, or presentations about our work',
          'Celebrate a child\'s milestone (always with explicit parent permission)'
        ]}
      />
    </LegalSection>

    <LegalSection heading="3. Your Consent">
      <LegalNote tone="info">
        We will only use any image that includes your child after we have asked
        you and received a clear &ldquo;yes&rdquo;. You can give, refuse, or
        change consent at any time without affecting your child&apos;s place in
        our programmes.
      </LegalNote>
    </LegalSection>

    <LegalSection heading="4. What We Will Not Do">
      <LegalList
        items={[
          'We will never publish a child\'s full name alongside an identifying photo.',
          'We will never share a child\'s image with third parties for advertising or commercial gain.',
          'We will never use a child\'s image in a way that could embarrass or disadvantage them.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="5. Withdrawing Consent or Asking Us to Remove an Image">
      <LegalParagraph>
        If you have previously given consent and would like to withdraw it — or
        if you ask us to remove a specific image — please email{' '}
        <a
          href="mailto:teacherkalah@gmail.com"
          className="text-[#3B4BA0] hover:underline"
        >
          teacherkalah@gmail.com
        </a>{' '}
        or WhatsApp us at{' '}
        <a
          href="https://wa.me/60166291687"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#3B4BA0] hover:underline"
        >
          +60 16-629 1687
        </a>
        . We will remove the requested image from materials we control as soon
        as reasonably possible.
      </LegalParagraph>
    </LegalSection>

    <LegalSection heading="6. Photos Already on the Website">
      <LegalParagraph>
        All photos currently used across the Read Right Academy website have
        been shared with the consent of the relevant parent or family. If you
        have any concern about an image you recognise, please contact us
        directly and we will respond promptly.
      </LegalParagraph>
    </LegalSection>
  </LegalLayout>
);

export default PhotoConsent;
